/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetAdminUserWalletDetailPageListRespVo } from './PageDataGetAdminUserWalletDetailPageListRespVo';
import {
    PageDataGetAdminUserWalletDetailPageListRespVoFromJSON,
    PageDataGetAdminUserWalletDetailPageListRespVoFromJSONTyped,
    PageDataGetAdminUserWalletDetailPageListRespVoToJSON,
    PageDataGetAdminUserWalletDetailPageListRespVoToJSONTyped,
} from './PageDataGetAdminUserWalletDetailPageListRespVo';

/**
 * 
 * @export
 * @interface GetAdminUserWalletDetailListWithSummaryRespVo
 */
export interface GetAdminUserWalletDetailListWithSummaryRespVo {
    /**
     * 
     * @type {PageDataGetAdminUserWalletDetailPageListRespVo}
     * @memberof GetAdminUserWalletDetailListWithSummaryRespVo
     */
    pageData?: PageDataGetAdminUserWalletDetailPageListRespVo;
    /**
     * 入金总额（intOutType=1 的 amount 合计）
     * @type {number}
     * @memberof GetAdminUserWalletDetailListWithSummaryRespVo
     */
    totalInAmount?: number;
    /**
     * 出金总额（intOutType=0 的 amount 合计）
     * @type {number}
     * @memberof GetAdminUserWalletDetailListWithSummaryRespVo
     */
    totalOutAmount?: number;
}

/**
 * Check if a given object implements the GetAdminUserWalletDetailListWithSummaryRespVo interface.
 */
export function instanceOfGetAdminUserWalletDetailListWithSummaryRespVo(value: object): value is GetAdminUserWalletDetailListWithSummaryRespVo {
    return true;
}

export function GetAdminUserWalletDetailListWithSummaryRespVoFromJSON(json: any): GetAdminUserWalletDetailListWithSummaryRespVo {
    return GetAdminUserWalletDetailListWithSummaryRespVoFromJSONTyped(json, false);
}

export function GetAdminUserWalletDetailListWithSummaryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminUserWalletDetailListWithSummaryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'pageData': json['pageData'] == null ? undefined : PageDataGetAdminUserWalletDetailPageListRespVoFromJSON(json['pageData']),
        'totalInAmount': json['totalInAmount'] == null ? undefined : json['totalInAmount'],
        'totalOutAmount': json['totalOutAmount'] == null ? undefined : json['totalOutAmount'],
    };
}

export function GetAdminUserWalletDetailListWithSummaryRespVoToJSON(json: any): GetAdminUserWalletDetailListWithSummaryRespVo {
    return GetAdminUserWalletDetailListWithSummaryRespVoToJSONTyped(json, false);
}

export function GetAdminUserWalletDetailListWithSummaryRespVoToJSONTyped(value?: GetAdminUserWalletDetailListWithSummaryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageData': PageDataGetAdminUserWalletDetailPageListRespVoToJSON(value['pageData']),
        'totalInAmount': value['totalInAmount'],
        'totalOutAmount': value['totalOutAmount'],
    };
}

